
(function ($) {
  'use strict';

  Drupal.behaviors.carousel = {
    attach: function (context, settings) {
      $(function () {
        var $target = $('.js-carousel', context),
          options, swiper;

        if ($target.find('.swiper-slide').size < 2) {
          return;
        }

        options = $.extend({
          loop: Modernizr.csstransforms3d ? true : false,
          autoHeight: true,
          spaceBetween: 20,
          slidesPerView: Modernizr.csstransforms3d ? 'auto' : 1,
          pagination: '.swiper-pagination',
          paginationClickable: true,
          prevButton: '.swiper-button-prev',
          nextButton: '.swiper-button-next'
        }, $.parseJSON($target.attr('data-options')));

        swiper = $target.swiper(options);

        $(window).on('items-resized', function (e, groups) {
          swiper.onResize();
        });
      });
    }
  };

})(jQuery);
